// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input, .TextArea {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 16px;
  padding-left: 16px;
  background-color: #F7F8FC;
  width: 100%;
  font-size: 16px;
  font-family: "Montserrat Regular";
  border: none;
  outline: none;
  border-radius: 8px;
}
.Input.error, .error.TextArea {
  border: 1px solid #eb5757;
}

.TextArea {
  background-color: #eff0f4;
  height: 100px;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/Input.scss","webpack://./src/assets/styles/colorsVariables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AADF;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,yBCrBgB;EDuBhB,aAAA;EACA,YAAA;AAHF","sourcesContent":["@import '~@assets/styles/colorsVariables.scss';\r\n\r\n.Input {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  padding-right: 16px;\r\n  padding-left: 16px;\r\n  background-color: #F7F8FC;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  font-family: 'Montserrat Regular';\r\n  border: none;\r\n  outline: none;\r\n  border-radius: 8px;\r\n\r\n  &.error {\r\n    border: 1px solid #eb5757;\r\n  }\r\n}\r\n\r\n.TextArea {\r\n  background-color: $backGroundColor;\r\n  @extend .Input;\r\n  height: 100px;\r\n  resize: none;\r\n}\r\n","$backGroundColor: #eff0f4;\r\n$sidebarColor: #2C274B;\r\n\r\n$mainColor: #c6f432;\r\n\r\n$toggleAndSuccessState: #4ce417;\r\n$error: #e50000;\r\n\r\n$text: #000000;\r\n$secondaryText: #898989;\r\n\r\n$hoverButton: #aee10c;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Input": `Input`,
	"TextArea": `TextArea`,
	"error": `error`
};
export default ___CSS_LOADER_EXPORT___;
